// extracted by mini-css-extract-plugin
module.exports = {"text":"Title_text__3e-3i","sub-title":"Title_sub-title__1vrz9"};